import React from 'react';

const ComingSoons = () => {
  return (
    <div className='error-page'>
      <p className='error-text'>Coming Soon</p>
    </div>
  );
};
 
export default ComingSoons;